import * as React from 'react';
import * as routes from './routes';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import HomePage from './pages/HomePage';
import NoMatchPage from './pages/NoMatchPage';
import WorkPage from './pages/WorkPage';
import BlogPage from './pages/BlogPage';
import AboutPage from './pages/AboutPage';
import { MainLayout } from './components/layout/MainLayout';
import GlobalStyles from './themes/common';
import original from './themes/original';
import { ThemeProvider } from 'styled-components';
import { QueryClient, QueryClientProvider } from 'react-query';
import BlogPostPage from './pages/BlogPostPage';
import ScrollToTop from './utils/ScrollToTop';

function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={original}>
        <Router>
          <GlobalStyles />
          <ScrollToTop />
          <MainLayout>
            <Switch>
              <Route exact path={routes.home} component={HomePage} />
              <Route exact path={routes.work} component={WorkPage} />
              <Route exact path={routes.blog} component={BlogPage} />
              <Route exact path={routes.blogPost} component={BlogPostPage} />
              <Route exact path={routes.about} component={AboutPage} />
              <Route component={NoMatchPage} />
            </Switch>
          </MainLayout>
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
